module.exports = __webpack_public_path__ + "static/media/6-广联达BIM+技术管理系统.fb2e1b14.png";